import { useState } from "react"
import { TFilters } from "../../../../../components/TableDataGridV2/types"
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TextField,
    Typography
} from "@mui/material"
import { permitirApenasNumeros } from "../../../../../helpers/masks"
import CloseIcon from '@mui/icons-material/Close';

export default function PreFiltros({
    filtros,
    onConfirm,
    open,
    onClose
}: PreFiltrosProps) {
    const [internFilters, setInternFilters] = useState(filtros)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };
        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('departamento')) {
                novoObjeto.departamento_label_pesquisar = novoObjeto[key].id;
                delete novoObjeto[key];
            }
        });
        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onConfirm(formatValue)
        onClose()
    }

    const clearFilters = () => {
        const emptyFilters = {};
        setInternFilters(emptyFilters);
        onConfirm(filtrarObj(emptyFilters));
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Filtrar Lojas</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box py={2}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Código"
                                variant="outlined"
                                fullWidth
                                value={internFilters.id_pesquisar || ''}
                                onChange={(e) => {
                                    handleInsertFiltros("id_pesquisar", permitirApenasNumeros(e.target.value))
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Nome"
                                variant="outlined"
                                fullWidth
                                value={internFilters.nome_pesquisar || ''}
                                onChange={(e) => {
                                    handleInsertFiltros("nome_pesquisar", e.target.value)
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Razão social"
                                variant="outlined"
                                fullWidth
                                value={internFilters.razao_social_pesquisar || ''}
                                onChange={(e) => {
                                    handleInsertFiltros("razao_social_pesquisar", e.target.value)
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button
                    onClick={clearFilters}
                    color="error"
                    variant="outlined"
                >
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    Aplicar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface PreFiltrosProps {
    filtros: TFilters,
    onConfirm: (args: TFilters) => void
    open: boolean
    onClose: () => void
}